import React from 'react';
import { DrillDownEvolucaoVendasData } from './types';
import GenericTransactionDrillDown from './GenericTransactionDrillDown';

interface EvolucaoVendasDrillDownProps {
  data: DrillDownEvolucaoVendasData;
}

const EvolucaoVendasDrillDown: React.FC<EvolucaoVendasDrillDownProps> = ({ data }) => {
  return (
    <GenericTransactionDrillDown 
      data={data}
      transactionType="vendas"
    />
  );
};

export default EvolucaoVendasDrillDown; 